import { Store } from "common/data/store.logic";
import { ChatbotResource } from "core/stages-client";
import { ChatHistoryService } from "chatbot/menu/history/chat-history.service";
import ChatHistoryEntry = stages.chatbot.ChatHistoryEntry;

export class ChatHistoryStore implements Store<ChatHistoryEntry> {
	constructor(
		private chatbotResource: ChatbotResource,
		private chatHistoryService: ChatHistoryService,
		private pageSize: number,
	) {}

	async getPage(pageIndex: number): Promise<PagedResult<ChatHistoryEntry>> {
		return this.chatbotResource.getChatHistory({
			page: pageIndex,
			pageSize: this.pageSize,
		});
	}

	async delete(chatGuids: string[], pageIndex: number): Promise<PagedResult<ChatHistoryEntry>> {
		return this.chatHistoryService.delete(chatGuids, 1, this.pageSize, this.pageSize * pageIndex);
	}
}
